import {Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {MatIconRegistry} from '@angular/material/icon';
import {DomSanitizer} from '@angular/platform-browser';

// import {DateAdapter} from '@angular/material/core';

export interface Language {
  code: string;
  name: string;
  flag: string;
}

@Injectable({
  providedIn: 'root'
})
export class LanguageService {

  languages: Language[] = [
    {code: 'en', name: 'English', flag: 'gb'},
    {code: 'it', name: 'Italiano', flag: 'it'},
    // Disabled for the it/en-only release. Re-enable together with the localeJa
    // registration in main.ts, the ['en','it','ja'] assertions in
    // language.service.spec.ts, and the store copy in store-assets/LISTING.md.
    // {code: 'ja', name: '日本語', flag: 'jp'},
    // {code: 'de', name: 'Deutsch', flag: 'de'}
  ];
  currentLanguage?: Language;

  constructor(private ts: TranslateService,
              private iconRegistry: MatIconRegistry,
              // private dateAdapter: DateAdapter<Date>,
              private sanitizer: DomSanitizer) {
    this.initializeLanguage();
  }

  getLanguageByCode(code: string) {
    return this.languages.find((l) => l.code === code);
  }

  setLanguageByCode(code: string) {
    this.setLanguage(this.getLanguageByCode(code) ?? this.languages[0]);
  }

  setLanguage(l: Language) {
    this.currentLanguage = l;
    localStorage.setItem('language', l.code);
    this.ts.use(l.code);
  }

  private initializeLanguage() {
    for (const l of this.languages) {
      this.iconRegistry.addSvgIcon(l.flag, this.sanitizer.bypassSecurityTrustResourceUrl(`/assets/flags/${l.flag}.svg`));
    }

    const browserLang = this.ts.getBrowserLang();
    this.currentLanguage = this.getLanguageByCode(localStorage.getItem('language') ?? browserLang ?? 'en') ?? this.languages[0];
    this.ts.addLangs(this.languages.map(l => l.code));
    this.ts.setFallbackLang(this.currentLanguage.code);
    this.ts.use(this.currentLanguage.code);
    this.ts.onLangChange.subscribe((change) => {
      // this.dateAdapter.setLocale(change);
      console.log('langChange', change);
    })

  }
}
